import { StreetType } from "./enums";
import { Timestamp } from "firebase/firestore";

export enum HistoricalDataStatus {
  PENDING = "PENDING", // Można importować
  IMPORTED = "IMPORTED", // Zaimportowano
  REJECTED = "REJECTED", // Odrzucono na zawsze
  SKIPPED = "SKIPPED", // Pomiń teraz, ale można później
}

export interface SystemFlags {
  historicalDataStatus?: HistoricalDataStatus;
  historicalDataImportedAt?: Timestamp;
  historicalDataRejectedAt?: Timestamp;
  // Przyszłe flagi systemowe
  notificationsEnabled?: boolean;
  betaFeaturesEnabled?: boolean;
}

export interface AppUser {
  consents: ClientConsent[];
  email: string;
  firstName: string;
  id: string;
  invoiceData?: InvoiceData;
  isActive: boolean;
  isFirstLogin: boolean;
  lastName: string;
  isInvoiceNeeded: boolean;
  organizationName?: string;
  phoneNumber: string;
  systemFlags?: SystemFlags;
  roles?: string[];  // Tablica ról użytkownika
}

export interface InvoiceData {
  city: string;
  houseNumber: string;
  localNumber?: string;
  name: string;
  postalCode: string;
  street: string;
  streetType: StreetType;
  taxId: string;
}

export interface ClientConsent {
  code: string;
  consentDate: Date;
  consentGiven: boolean;
  consentText: string;
}
